<script lang="ts">
  import Cashback from '$components/+cashback.svelte';
  import { modifyImageUrl } from '$utils/formatters';
  import type { Item } from '$types';

  export let item: Item;
  export let template: 'large' | 'small' | 'featured' | 'related';
  export let href: string;
</script>

<div class="embla__slide campaign-card campaign-{template}" data-uuid={item.uuid}>
  {#if template === 'large'}
    <figure class="image">
      {#if item.images?.banner}
        <img src={modifyImageUrl(item.images.banner, { width: 1000 })} alt={item.name} />
      {/if}
    </figure>
    {#if item.cashback_text && !item.hide_cashback}
      <Cashback cashback_text={item.cashback_text} position="corner" size="large" />
    {:else if !item.hide_cashback}
      <Cashback cashback={item.first_time_cashback} position="corner" size="large" />
    {/if}
    <div class="content">
      <h3>{item.name}</h3>
      <div class="description">
        {#if item.short_description_extended}
          {item.short_description_extended}
        {:else}
          {item.short_description}
        {/if}
      </div>
      <a {href} class="cta">Gå til kampagnen</a>
    </div>
  {:else if template === 'small'}
    <a {href} class="link" style="display:block;">
      <div class="card-hero">
        <figure class="image">
          {#if item.images?.featured}
            <img src={modifyImageUrl(item.images.featured, { width: 750 })} alt={item.name} />
          {/if}
        </figure>
        {#if !item.hide_cashback}
          <Cashback cashback={item.first_time_cashback} position="corner" />
        {/if}
        <div class="card-logo">
          {#if item.images?.logo}
            <img src={modifyImageUrl(item.images.logo, { width: 200 })} alt={item.name} />
          {/if}
        </div>
      </div>

      <div class="content">
        <h3>{item.name}</h3>
        <div class="description">{item.short_description}</div>
      </div>
    </a>
  {:else if template === 'featured'}
    <a {href} class="link">
      <div class="card-hero">
        <figure class="image">
          {#if item.images?.slider}
            <img src={modifyImageUrl(item.images.slider, { width: 750 })} alt={item.name} />
          {/if}
        </figure>
        {#if !item.hide_cashback}
          <Cashback cashback={item.first_time_cashback} position="corner" />
        {/if}
        <div class="card-logo">
          {#if item.images?.logo}
            <img src={modifyImageUrl(item.images.logo, { width: 200 })} alt={item.name} />
          {/if}
        </div>
      </div>

      <div class="content">
        <h3>{item.short_description}</h3>
        {#if item.short_description_extended}
          <div class="description">{item.short_description_extended}</div>
        {/if}
      </div>
    </a>
  {:else if template === 'related'}
    <a {href} class="link" style="display:block;">
      <div class="card-hero">
        <figure class="image">
          {#if item.images?.banner}
            <img src={modifyImageUrl(item.images.banner, { width: 500 })} alt={item.name} />
          {/if}
        </figure>
        {#if !item.hide_cashback}
          <Cashback cashback={item.first_time_cashback} position="corner" />
        {/if}
        <div class="card-logo">
          {#if item.images?.logo}
            <img src={modifyImageUrl(item.images.logo, { width: 200 })} alt={item.name} />
          {/if}
        </div>
      </div>

      <div class="content">
        <h3>{item.short_description}</h3>
        {#if item.short_description_extended}
          <div class="description">{item.short_description_extended}</div>
        {/if}
      </div>
    </a>
  {/if}
</div>
